import { useEffect, useMemo, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'

import TextArea from '@components/shared/TextArea'
import { Selectbox } from '@components/shared/Selectbox'
import CustomModal from '@/components/shared/CustomModal/CustomModal'

/* type Props = {
    showAddCollection: boolean
    showHideAddCollection: (showAddCollection: boolean) => void
    setSaveDocument: (saveDocument: boolean) => void
    setCollectionId: (collectionId: string) => void
    documentName: string
    id: string
    showPopUp: null | boolean
    setShowPopUp: (showPopUp: null | boolean) => void
    uploadMax: number
    uploadValue: number
    uploadError?: string | null
    isUploading: boolean
}
type IEvent = {
    target: {
        name: string
        value: string
    }
} */

const AddOrCreateCollection = ({
    showAddCollection,
    setShowAddCollection,
    collectionId,
    setCollectionId,
    uploadedFiles,
    setUploadedFiles,
    setShowUploadPopUp,
}) => {
    
    const allCollections = useWireValue(store.collections)
    
    const [values, setValues] = useState({
        userId: localStorage.getItem('userId') || '',
        creatorId: localStorage.getItem('userId') || '',
        name: '',
        state: '',
        county: '',
        description: '',
    })
    
    const docsUploadingCountMessage = useMemo(() => {
        
        const docLen = uploadedFiles.length
        
        return (
            (docLen > 1 ? 'are ' : 'is ') +
            docLen + (docLen > 1 ? ' documents ' : ' document ')
        )
        
    }, [uploadedFiles])
    
    useEffect(() => {
        actions.fetchCollections({
            offset: 0,
            limit: 20,
        })
    }, [])
    
    const handleChangeSelect = (value = '') => {
        setCollectionId(value)
    }
    
    const handleChangeValue = e => {
        const inputValue = { [e.target.name]: e.target.value }
        
        setValues({ ...values, ...inputValue })
    }
    
    const handleModal = () => {
        setUploadedFiles(null)
        setCollectionId(null)
        setShowAddCollection(false)
    }
    
    const uploadDocument = () => {
        setShowUploadPopUp(true)
        setShowAddCollection(false)
    }
    
    const createNewCollection = async e => {
        e.preventDefault()
        
        if (values) {
            const collection = await actions.createCollection(values)
            
            await actions.fetchCollections({
                offset: 0,
                limit: 20,
            })
            setCollectionId(collection.id)
            setShowUploadPopUp(true)
            setShowAddCollection(false)
        }
    }
    
    return (
        <CustomModal open={showAddCollection} modalHandler={() => handleModal()} center>
            <div>
                <h2 className="">Choose the collection for storing your document(s)</h2>
            </div>
            <div className="flex flex-col -ml-5 -mr-5 -mb-5 mt-3 pt-3 rounded-b-lg p-5">
                <span
                    className="text-slate-400 text-sm">
                    There {docsUploadingCountMessage + 'being uploaded.'}</span>
                <div className="flex flex-col ">
                    <div className="py-4 flex flex-col items-center gap-4 w-full">
                        <div className="w-full flex justify-between gap-3">
                            <label>Collection</label>
                            <Selectbox
                                className="w-9/12"
                                name="name"
                                options={allCollections.rows?.map(collection => ({
                                    label: collection.name,
                                    value: collection.id,
                                }))}
                                handleChange={(e, value) => handleChangeSelect(value?.value)} />
                        </div>
                        <button
                            className="RunsheetUploadFile--AddOrCreateCollectionButton btn btn-primary w-28"
                            onClick={uploadDocument}
                            disabled={!collectionId || !!values.name}>
                                Save
                        </button>
                        <p className="text-lg"> OR </p>
                    </div>
                </div>
                <h2 className="pb-4 text-center">Create a new collection</h2>
                <form onSubmit={createNewCollection}>
                    <div className="flex gap-3 flex-col">
                        <div className="flex gap-3 items-start justify-between">
                            <label>Name</label>
                            <input
                                type="text"
                                name="name"
                                className="input w-9/12"
                                value={values.name}
                                required={true}
                                onChange={handleChangeValue}
                                placeholder="Collection Name"/>
                        </div>
                        <div className="flex gap-3 items-start justify-between">
                            <label>State</label>
                            <input
                                type="text"
                                name="state"
                                className="input w-9/12"
                                value={values.state}
                                onChange={handleChangeValue}
                                placeholder="State"/>
                        </div>
                        <div className="flex gap-3 items-start justify-between">
                            <label>County</label>
                            <input
                                type="text"
                                name="county"
                                className="input w-9/12"
                                value={values.county}
                                onChange={handleChangeValue}
                                placeholder="County"/>
                        </div>
                        <div className="flex gap-3 items-start justify-between">
                            <label>Description</label>
                            <TextArea
                                name="description"
                                className="input w-9/12"
                                placeholder="Collection description..."
                                onChange={handleChangeValue}
                                value={values.description} />
                        </div>
                    </div>
                    <div className="flex flex-col items-center pt-3">
                        <button className="btn btn-primary" disabled={!values.name} type="submit">
                            Save to new Collection
                        </button>
                    </div>
                </form>
            </div>
        
        </CustomModal>
    )
}

export default AddOrCreateCollection
